module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "AdvancePraise",
    attrs: {
      "id": "AdvancePraise"
    }
  }, [_c('h2', {
    staticClass: "paraCenter-A"
  }, [_vm._v("Advance Praise for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Once a Marine")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent2"
  }, [_vm._v("“If you want an honest answer, ask a Marine. If you want an honest view of a war, ask a Marine gunnery sergeant. Nick Popaditch’s transcendent memoir of military service and its personal consequences should be read by every one of our nation’s political leaders—to help them understand the incomparable quality of those who fight on the front lines. Read this inspiring story, recommend it to friends—and send a copy to your member of Congress!”")]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_vm._v("— Ralph Peters (Lt. Col., ret.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Post")]), _vm._v(" columnist and author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Looking For Trouble")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wars Of Blood and Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("“America has always been blessed by wonderful, patriotic, and often anonymous men and women who have sacrificed so much in defense of liberty and freedom. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Once a Marine")]), _vm._v(", Gunny Sergeant Nick Popaditch’s heart-wrenching and inspiring memoir, puts a name and a face on this sacrifice. Every American should read this book to remind them of what these brave warriors of freedom endure on our behalf.”")]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_vm._v("— Congressman Bob Filner, Chairman of the House Committee on Veterans’ Affairs")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("“Gunny Popaditch’s story is as inspiring as it is dramatic. This wounded warrior suffered grievous injuries — an RPG to the head! — but refused to give up on life, even when his wounds forced him out of the Corps. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Once a Marine")]), _vm._v(" is a ‘must read’ story of one of today’s real heroes.”")]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_vm._v("— Jerry D. Morelock, PhD, Colonel, U. S. Army (Ret.), Editor in Chief, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Armchair General")]), _vm._v(" magazine")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("“Author Gunny Sergeant Nick Popaditch, a Silver Star recipient and the subject of the world-famous AP photo, has penned what must surely be classed as among the best personal memoirs of any combat soldier in recent memory. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Once a Marine")]), _vm._v(" is an in-your-face blast of raw emotion and realism that will strike a raw nerve and keep you up at night. This autobiography of combat, courage, and recovery should be required reading for every American, young and old, who yearns to grasp the true cost of freedom.”")]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_vm._v("— Caspar Weinberger Jr., Military and Current Affairs Columnist")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("“A riveting and inspirational story of the consummate professional warrior. It is impossible to read "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Once a Marine")]), _vm._v(" without being proud of our military and grateful that our Nation produces men like Gunnery Sergeant Nick Popaditch.”")]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_vm._v("— Michael F. Nugent, Major, US Army (Ret.), co-author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("One Continuous Fight: The Retreat From Gettysburg and the Pursuit of Lee’s Army of Northern Virginia, July 4-14, 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("“Gunny Popaditch’s story makes me incredibly proud to have worn the same uniform. Without intending to, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Once a Marine")]), _vm._v(" articulates life in the modern Marine Corps more clearly than anything I’ve read. No blindly loyal fanatic, Popaditch candidly acknowledges the bullshit, yet artfully captures the inimitable spirit of camaraderie and commitment that makes the Marine Corps unique. Extraordinarily motivating and compellingly honest book, it made me pine for my own long-finished Marine Corps career.”")]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_vm._v("— Jay A. Stout, Lt.Col. USMC (Ret.), author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hornet’s Over Kuwait")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("“‘Gunny Pop’ Popaditch’s courageous memoir of his life in and out of the Marine Corps is intelligently written and imbued with a brazen honesty rarely found elsewhere. His personal courage—and that of his wife, April—gives the term “home of the brave” an entirely new meaning.”")]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_vm._v("— Sgt. Michael Volkin, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Ultimate Basic Training Guidebook: Tips, Tricks, and Tactics for Surviving Boot Camp")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70680f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnceAMarine_advance.vue
// module id = 57
// module chunks = 0